import { Picture } from "../../../Components/PhotosApp/PhotoViewer/PhotoInterfaces";
import Profile_1 from "./WhiteHouseTweeterAssets/Tweeter-Profile-1.webp";
import Profile_2 from "./WhiteHouseTweeterAssets/Tweeter-Profile-2.webp";
import ContentPicture from "./WhiteHouseTweeterAssets/Tweeter-Pic-1.webp";

export interface Comment {
  icon?: string;
  date: string;
  author: string;
  handle: string;
  likes: number;
  content: string;
}

export interface Tweet {
  icon?: string;
  date: string;
  time: string;
  author: string;
  handle: string;
  verified: string;
  content: string | Picture;
  contentImage?: string;
  likes: number;
  retweets: number;
  quotes: number;
  comments?: Comment[];
}

export const WhiteHouseTweetContent: Tweet[] = [
  {
    icon: Profile_1,
    date: "4 Dec 2022",
    time: "11:12 AM",
    author: "Le Pays",
    handle: "@lepaysatcu",
    verified: "Verified.webp",
    content:
      "Will George McFarlane's atheism stop him from winning Southern states again in 2024? | Antoine Alessandrini",
    contentImage: ContentPicture,
    likes: 181,
    retweets: 84,
    quotes: 14,
  },
  {
    icon: Profile_2,
    date: "7 Dec 2022",
    time: "5:58 PM",
    author: "Julia Denyer",
    handle: "@JuilaUSPol",
    verified: "Verified.webp",
    content:
      "Just been speaking to @DianaViyanga and @FrankGolding_Dem after their 5pm press conference addressing reports of inner turmoil at the White House. The Democrats understandably trying hard to turn the page on the President's affair scandal.",
    likes: 3298,
    retweets: 47,
    quotes: 7,
  },
];
